<script lang="ts">
    import { Button, Spinner } from '@sveltestrap/sveltestrap';

    export let loading = false;
</script>

<Button {...$$restProps} on:click>
    {#if loading }
        <Spinner size="sm" />
    {:else}
        <slot/>
    {/if}
</Button>
